export default __webpack_public_path__ + "static/media/FOTOS_DISCO_04.306c5830.jpg";